import { render, staticRenderFns } from "./AdminCompany.vue?vue&type=template&id=0345da00&"
import script from "./AdminCompany.vue?vue&type=script&lang=js&"
export * from "./AdminCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports